"use client";
import { Laptop, MoonStar, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useTheme } from "./theme-provider";

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  return (
    <div className={cn("bg-muted relative flex items-center rounded-full border p-1", className)}>
      <div
        className={cn(
          "bg-background absolute top-1 left-1 h-8 w-8 rounded-full shadow-sm transition-transform duration-200",
          theme === "system" ? "translate-x-0" : theme === "light" ? "translate-x-full" : "translate-x-[200%]",
        )}
      />
      <Button
        variant="ghost"
        size="icon"
        className="z-10 h-8 w-8 rounded-full"
        onClick={() => setTheme("system")}
        aria-label="System theme"
      >
        <Laptop className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="z-10 h-8 w-8 rounded-full"
        onClick={() => setTheme("light")}
        aria-label="Light theme"
      >
        <Sun className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="z-10 h-8 w-8 rounded-full"
        onClick={() => setTheme("dark")}
        aria-label="Dark theme"
      >
        <MoonStar className="size-4" />
      </Button>
    </div>
  );
}
